/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {gsap} from "gsap";

export class BenjiKIVBackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundMain:PIXI.Sprite;
    private _backgroundFS:PIXI.Sprite;
    private _backgroundSuperFS:PIXI.Sprite;
    private _currentBackground:PIXI.Sprite;
    private _newBackground:PIXI.Sprite;
    private _currentMode:string = "";

    constructor() {
        super();
        this.name = "BenjiKIVBackgroundElements";
        this.init();
    }

    private init() {
        this._backgroundMain = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(BenjiKIVGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundMain.position.set(360, 360);
        this._backgroundMain.anchor.set(0.5, 0.5);
        this._backgroundMain.alpha = 0;
        this.addChild(this._backgroundMain);

        if (BenjiKIV.apiPlugin.gameClientConfiguration.useCensoredGfxUS) {
            this._backgroundFS = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(BenjiKIVGameAssets.FS_BACKGROUND_WV)[0]);
        } else {
            this._backgroundFS = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(BenjiKIVGameAssets.FS_BACKGROUND)[0]);
        }
        this._backgroundFS.position.set(360, 360);
        this._backgroundFS.anchor.set(0.5, 0.5);
        this._backgroundFS.alpha = 0;
        this.addChild(this._backgroundFS);

        this._backgroundSuperFS = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures(BenjiKIVGameAssets.SUPER_FS_BACKGROUND)[0]);
        this._backgroundSuperFS.position.set(360, 360);
        this._backgroundSuperFS.anchor.set(0.5, 0.5);
        this._backgroundSuperFS.alpha = 0;
        this.addChild(this._backgroundSuperFS);

        this._currentBackground = new PIXI.Sprite();
    }

    private swapBackgroundTo(newBackground:PIXI.Sprite) {
        this._newBackground = newBackground;
        this.addChild(this._newBackground);
        const switchBackgroundTL:gsap.core.Timeline = gsap.timeline();
        switchBackgroundTL.add([
            gsap.to(this._newBackground, {duration : 0.5, alpha : 1}),
            gsap.to(this._currentBackground, {duration : 0.4, alpha : 0, delay : 0.1})
        ]);
        switchBackgroundTL.add(() => {this._currentBackground = this._newBackground});
    }

    public setMode(mode:string) {
        if (mode == this._currentMode){
            return;
        }
        this._currentMode = mode;
        if(mode == BenjiKIVGameMode.FREESPIN) {
            this.swapBackgroundTo(this._backgroundFS);
        } else if(mode == BenjiKIVGameMode.SUPER_FREESPIN) {
            this.swapBackgroundTo(this._backgroundSuperFS);
        } else {
            this.swapBackgroundTo(this._backgroundMain);
        }
    }
}